import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
} from "@mui/material";

// Icons
import FlashOnIcon from "@mui/icons-material/FlashOn";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TuneIcon from "@mui/icons-material/Tune";
import LockIcon from "@mui/icons-material/Lock";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import PortraitIcon from "@mui/icons-material/Portrait";
import LanguageIcon from "@mui/icons-material/Language";

/* ✅ Each card has its own gradient */
const features = [
  {
    title: "100% Free",
    description:
      "Create unlimited marriage biodata formats for free without any cost or signup.",
    icon: <WorkspacePremiumIcon />,
    gradient: "linear-gradient(135deg, #43cea2, #185a9d)",
  },
  {
    title: "Multi-Language Support",
    description:
      "Create biodata in English, Hindi (हिंदी), or Marathi (मराठी) instantly.",
    icon: <LanguageIcon />,
    gradient: "linear-gradient(135deg, #ff7e5f, #feb47b)",
  },
  {
    title: "Cover Image Support",
    description:
      "Add a cover image to your biodata for a more personalized look.",
    icon: <PortraitIcon />,
    gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
  },
  {
    title: "Live Preview",
    description:
      "Preview your marriage biodata format live as you enter your details.",
    icon: <VisibilityIcon />,
    gradient: "linear-gradient(135deg, #00c6ff, #0072ff)",
  },
  {
    title: "Fully Customizable",
    description:
      "Add, remove, or rename fields to match your requirements.",
    icon: <TuneIcon />,
    gradient: "linear-gradient(135deg, #a18cd1, #fbc2eb)",
  },
  {
    title: "Fast Creation",
    description:
      "Create and download your marriage biodata PDF in under 5 minutes.",
    icon: <FlashOnIcon />,
    gradient: "linear-gradient(135deg, #ff512f, #dd2476)",
  },
  {
    title: "Privacy First",
    description:
      "Your marriage biodata data stays private and is never stored.",
    icon: <LockIcon />,
    gradient: "linear-gradient(135deg, #11998e, #38ef7d)",
  },
  {
    title: "Mobile Friendly",
    description:
      "Works seamlessly on mobile, tablet, and desktop devices.",
    icon: <PhoneIphoneIcon />,
    gradient: "linear-gradient(135deg, #fc466b, #3f5efb)",
  },
];

export default function WhyChooseUs() {
  return (
    <Box sx={{ py: { xs: 6, md: 8 }, background: "#fff" }}>
      <Container maxWidth="lg">
        {/* ===== Heading ===== */}
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontWeight: 800,
            mb: 1,
          }}
        >
          Why Choose Our Free Marriage Biodata Maker Online?
        </Typography>

        <Typography
          align="center"
          sx={{
            color: "#666",
            mb: 5,
            maxWidth: 720,
            mx: "auto",
          }}
        >
          Create a professional marriage biodata format online with our free
          biodata maker. Customize your profile, choose templates, and download
          your biodata PDF instantly — no signup required.
        </Typography>

        {/* ===== Cards ===== */}
        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid key={index} item xs={12} sm={6} md={4}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  border: "1px solid #EFEFEF",
                  transition: "all 0.3s ease",
                  textAlign: "center",

                  "&:hover": {
                    transform: "translateY(-6px) scale(1.02)",
                    boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
                    borderColor: "#FFD2B3",
                  },
                }}
              >
                <CardContent
                  sx={{
                    p: 3,
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* ===== ICON WITH GLOW ===== */}
                  <Box
                    sx={{
                      position: "relative",
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      background: feature.gradient,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: "auto",
                      mb: 2,
                      color: "#fff",
                      fontSize: 26,
                      zIndex: 1,
                      boxShadow: "0 6px 16px rgba(0,0,0,0.2)",

                      /* 🔥 Glow */
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        width: 70,
                        height: 70,
                        borderRadius: "50%",
                        background: feature.gradient,
                        filter: "blur(20px)",
                        opacity: 0.4,
                        zIndex: -1,
                      },

                      "&:hover::before": {
                        opacity: 0.6,
                        transform: "scale(1.1)",
                      },
                    }}
                  >
                    {feature.icon}
                  </Box>

                  {/* ===== Title ===== */}
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "1.05rem",
                      mb: 1,
                    }}
                  >
                    {feature.title}
                  </Typography>

                  {/* ===== Description ===== */}
                  <Typography
                    sx={{
                      color: "#555",
                      fontSize: "0.95rem",
                      lineHeight: 1.6,
                    }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}